// #@flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "The ‘Profile embed’ creates an embeddable profile of a single person with written bio and statistics.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Profile embed",
  id: "profile-embed",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  // cradleIframeUrlRoot:"http://localhost:3000/index.html?resizable=true",
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/profile-embed/?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "ProfileEmbedConfigTool" */ "app/components/tools/ProfileEmbedConfigTool/ProfileEmbedConfigTool"),
    loading: DynamicImportLoader,
    modules: ["ProfileEmbedConfigTool"]
  })
};

export default CONFIG;
